// Counts down to the ISO date in data-target, refreshing the unit cells once per second.
class SCountdown extends HTMLElement {
  #timer = null;

  connectedCallback() {
    const target = Date.parse(this.dataset.target || '');
    if (Number.isNaN(target)) return;
    this.#target = target;
    this.#cells = {
      days: this.querySelector('[data-unit="days"]'),
      hours: this.querySelector('[data-unit="hours"]'),
      minutes: this.querySelector('[data-unit="minutes"]'),
      seconds: this.querySelector('[data-unit="seconds"]'),
    };
    this.#tick();
    this.#timer = setInterval(() => this.#tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.#timer);
  }

  #target = 0;
  #cells = {};

  #tick() {
    const remaining = Math.max(0, this.#target - Date.now());
    const totalSeconds = Math.floor(remaining / 1000);
    const values = {
      days: Math.floor(totalSeconds / 86400),
      hours: Math.floor((totalSeconds % 86400) / 3600),
      minutes: Math.floor((totalSeconds % 3600) / 60),
      seconds: totalSeconds % 60,
    };
    for (const [unit, value] of Object.entries(values)) {
      const cell = this.#cells[unit];
      if (cell) cell.textContent = String(value).padStart(2, '0');
    }
    if (remaining === 0) clearInterval(this.#timer);
  }
}

if (!customElements.get('s-countdown')) customElements.define('s-countdown', SCountdown);
